<template>
    <div class="ui-body">
        <!-- 01.主体容器 - 头部 Start -->
        <div class="ui-container-header">
            <!-- 01.01.主体容器 - 头部 - 标题 Start -->
            <h3 class="ui-container-header-title"><i class="ion-ios-arrow-forward"></i>{{ this.$route.meta.title }}</h3>
            <!-- 01.01.主体容器 - 头部 - 标题 End -->
            <!-- 01.02.主体容器 - 头部 - 副标题 Start -->
            <p class="ui-container-header-subtitle">{{ this.$route.meta.description }}</p>
            <!-- 01.02.主体容器 - 头部 - 副标题 End -->
            <!-- 01.03.主体容器 - 头部 - 按钮组 Start -->
            <div class="ui-container-header-group" v-if="$Permissions(['AdminLoginOperation'])">
                <el-button-group>
                    <el-button @click="operateAllRefresh" v-if="$Permissions(['AdminLoginOperationRefresh'])"><i class="ion-ios-refresh-circle"></i>刷新</el-button>
                </el-button-group>
            </div>
            <!-- 01.03.主体容器 - 头部 - 按钮组 End -->
        </div>
        <!-- 01.主体容器 - 头部 End -->

        <!-- 02.主体容器 - 内容 Start -->
        <div class="ui-container-content">
            <div class="ui-content">
                <!-- 02.01.主体容器 - 内容 - 搜索 Start -->
                <div class="ui-container-search">
                    <div class="ui-search-quick" v-if="$Permissions(['AdminLoginSearch'])">
                        <!-- 02.01.01.快捷搜索 Start -->
                        <div class="ui-search-quick-input" v-if="$Permissions(['AdminLoginSearchQuick'])">
                            <el-input placeholder="请输入用户名 / IP地址 / 日志内容 ..." v-model="quickSearch" class="input-with-select">
                                <el-button type="primary" slot="append" icon="el-icon-search" @click="clickQuickSearch"></el-button>
                            </el-input>
                        </div>
                        <!-- 02.01.01.快捷搜索 End -->
                        <!-- 02.01.02.更多搜索切换 Start -->
                        <div class="ui-search-quick-button" v-if="$Permissions(['AdminLoginSearchMore'])">
                            <el-button @click="searchState=!searchState">更多查询<i :class="searchState?'el-icon-arrow-up':'el-icon-arrow-down'"></i></el-button>
                        </div>
                        <!-- 02.01.02.更多搜索切换 End -->
                    </div>
                    <!-- 02.01.04.更多搜索表单 Start -->
                    <el-collapse-transition>
                        <div class="ui-search-more" v-show="searchState" v-if="$Permissions(['AdminLoginSearchMore'])">
                            <el-scrollbar>
                                <el-form ref="arraySearch" :model="arraySearch" :label-position="searchPosition">
                                <el-row :gutter="30">
                                    <el-col :span="8">
                                        <el-form-item label="管理员用户名" prop="user_name">
                                            <el-input v-model="arraySearch.user_name" placeholder="请输入管理员用户名"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="管理员姓名" prop="title">
                                            <el-input v-model="arraySearch.title" placeholder="请输入管理员姓名"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="管理员联系电话" prop="phone">
                                            <el-input v-model="arraySearch.phone" placeholder="请输入管理员联系电话"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="30">
                                    <el-col :span="8">
                                        <el-form-item label="登录方法" prop="mode">
                                            <el-select v-model="arraySearch.mode" clearable multiple placeholder="请选择登录方法">
                                                <el-option label="账号密码" value="0"></el-option>
                                                <el-option label="短信登录" value="1"></el-option>
                                                <el-option label="二维码登录" value="2"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="登录状态" prop="state">
                                            <el-select v-model="arraySearch.state" clearable multiple placeholder="请选择登录状态">
                                                <el-option label="登录失败" value="0"></el-option>
                                                <el-option label="登录成功" value="1"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="IP地址" prop="ip">
                                            <el-input v-model="arraySearch.ip" placeholder="请输入IP地址"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="30">
                                    <el-col :span="8">
                                        <el-form-item label="登录日志" prop="log">
                                            <el-input v-model="arraySearch.log" placeholder="请输入登录日志"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="登录时间" prop="datetime">
                                            <el-date-picker v-model="arraySearch.datetime" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            </el-scrollbar>
                            <div class="ui-search-more-group">
                                <el-button type="primary" icon="ion-ios-search" @click="clickArraySearch">搜索</el-button>
                                <el-button icon="ion-ios-repeat" @click="resetArraySearch">重置</el-button>
                            </div>
                        </div>
                    </el-collapse-transition>
                    <!-- 02.01.04.更多搜索表单 End -->
                </div>
                <!-- 02.01.主体容器 - 内容 - 搜索 End -->
                <!-- 02.02.主体容器 - 内容 - 表格 Start -->
                <div class="ui-container-table">
                    <el-table :data="tableData" height="100%" v-loading="tableLoading" v-if="$Permissions(['AdminLoginTable'])">
                        <el-table-column prop="mode" label="登录方法" width="120">
                            <template #default="scope">
                                <div v-if="scope.row.mode === 0">
                                    <el-tag type="primary">账号密码</el-tag>
                                </div>
                                <div v-if="scope.row.mode === 1">
                                    <el-tag type="success">短信登录</el-tag>
                                </div>
                                <div v-if="scope.row.mode === 2">
                                    <el-tag type="warning">二维码登录</el-tag>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="state" label="登录状态" width="120">
                            <template #default="scope">
                                <div v-if="scope.row.state === 0">
                                    <el-tag type="danger">登录失败</el-tag>
                                </div>
                                <div v-if="scope.row.state === 1">
                                    <el-tag type="success">登录成功</el-tag>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ip" label="登录IP地址" width="150"></el-table-column>
                        <el-table-column prop="log" label="登录日志"></el-table-column>
                        <el-table-column prop="add_date" label="登录时间" width="200"></el-table-column>
                    </el-table>
                </div>
                <!-- 02.02.主体容器 - 内容 - 表格 End -->
            </div>
        </div>
        <!-- 02.主体容器 - 内容 End -->

        <!-- 03.主体容器 - 尾部 Start -->
        <div class="ui-container-footer ">
            <!-- 03.02.主体容器 - 尾部 - 分页 Start -->
            <div class="ui-container-footer-pagination">
                <el-pagination background :current-page="tablePage" :page-sizes="pageSizes" :page-size="pageSize" :total="tableTotal" layout="sizes, prev, pager, next, jumper, total" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
            </div>
            <!-- 03.02.主体容器 - 尾部 - 分页 End -->
        </div>
        <!-- 03.主体容器 - 尾部 End -->
    </div>
</template>

<script>
    export default {
        name: "log_admin",
        data() {
            return {
                // 01.显示模式 ------------------------------------------------
                // 01.01.Html标题
                htmlTitle: this.$route.meta.title,
                // 01.02.Html描述
                htmlDescription: this.$route.meta.description,
                // 01.04.TreeID
                treeID: "",
                // 02.数据搜索 ------------------------------------------------
                // 02.01.快捷搜索
                quickSearch: '',
                // 02.02.更多搜索
                arraySearch: {
                    user_name: '',
                    title: '',
                    phone: '',
                    mode: [],
                    state: [],
                    ip: '',
                    log: '',
                    datetime: ''
                },
                // 02.03.Search 显示状态
                searchState: false,
                // 02.04.Search 配置 - 标题位置
                searchPosition: 'top',
                // 03.数据数组 ------------------------------------------------
                // 03.01.数据数组 - 数据集
                tableData: [],
                // 03.02.数据数组 - 加载组件
                tableLoading: true,
                // 04.分页栏目 ------------------------------------------------
                // 04.01.分页栏目 - 当前页
                tablePage: 1,
                // 04.02.分页栏目 - 数据总量
                tableTotal: 400,
                // 04.03.分页栏目 - 每页数量条数
                pageSizes: [20, 50, 100, 200],
                // 04.04.分页栏目 - 分页条数
                pageSize: 20,
            }
        },
        // 方法集合
        methods: {
            // 01.批量操作 ------------------------------------------------
            // 01.01.刷新
            operateAllRefresh() {
                this.getTableJson()
            },
            // 02.获取数据 ------------------------------------------------
            // 02.01.获取Json数据 ( tablePage 当前页  pageSize 分页条数  quickSearch 快捷搜索  arraySearch 更多搜索 )
            getTableJson() {
                this.arraySearch.quick_search = this.quickSearch
                this.arraySearch.table_page = this.tablePage
                this.arraySearch.page_size = this.pageSize
                this.$api.get('/api/get/admin-login-log/', this.arraySearch).then((response) => {
                    this.tableData = response.data
                    this.pageSize = response.page_size
                    this.tableTotal = response.table_total
                    this.tablePage = response.table_page
                    this.tableLoading = false
                })
            },
            // 02.02.分页栏目 - 分页数
            changeSize(val) {
                // 01.赋值分页数
                this.pageSize = val
                // 02.获取Json数据
                this.getTableJson()
            },
            // 02.03.分页栏目 - 跳转页
            changeCurrent(val) {
                // 01.赋值跳转页
                this.tablePage = val
                // 02.获取Json数据
                this.getTableJson()
            },
            // 03.搜索/查询操作 ------------------------------------------------
            // 03.01.快捷搜索/查询
            clickQuickSearch() {
                // 01.获取Json数据
                this.getTableJson()
            },
            // 03.02.搜索/查询 - 查询提交
            clickArraySearch() {
                // 01.获取Json数据
                this.getTableJson()
                this.searchState = false
            },
            // 03.03.搜索/查询 - 重置Form表单
            resetArraySearch() {
                this.$refs['arraySearch'].resetFields()
                this.getTableJson()
                this.searchState = false
            },
        },
        // 生命周期 - 挂载完成
        mounted() {
            // 01.获取Json数据
            this.getTableJson()
        },
    }
</script>
